<template>
	<el-card class="box-card " :class="className" style="margin-right: 8px;">
		<div slot="header" class="clearfix">
			<span><i class="el-icon-caret-right" style="color: #F1993F;"></i>{{title}}</span>
      
			 <el-button v-for="(item,index) in buttons" :key="index" 
       style="float: right; background:rgba(0,201,83,1);" 
       class="filter-item" @click="btnClick(item)" size="mini" type="success"  >{{item.name}}</el-button>
       
		</div>
		<slot></slot>
	</el-card>
</template>

<script>
	export default{
		props:['title','buttons','className'],
		computed:{
			getClass(){
				if(this.buttonName){
					return "customBoxCart";
				}
				return ""
			}
		},
		methods:{
			btnClick(item){
				this.$emit("btnCustomClick",item.classify)
			}
		}
	}
</script>

<style lang="scss">
	.customBoxCart{
		.el-card__header{
			padding:13px 20px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/CustomCard/index2.vue